(() => {
  const rootUrl = () => window.Shopify?.routes?.root || '/';
  let notificationTimer;

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
        maximumFractionDigits: 2,
      }).format(Number(cents) / 100);
    } catch (_) {
      return '$' + (Number(cents) / 100).toFixed(2);
    }
  }

  function updateCartCount(count) {
    const cartIcon = document.querySelector('cart-icon');
    if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
      cartIcon.renderCartBubble(count);
      return;
    }
    const bubble = document.querySelector('[ref="cartBubble"]');
    const bubbleCount = document.querySelector('[ref="cartBubbleCount"]');
    if (bubbleCount) {
      bubbleCount.textContent = count < 100 ? String(count) : '';
      bubbleCount.classList.toggle('hidden', count === 0);
    }
    bubble?.classList.toggle('visually-hidden', count === 0);
  }

  function showNotification(message, count) {
    const notification = document.querySelector('[data-lh-cart-notification]');
    if (!notification) return;
    const copy = notification.querySelector('[data-lh-notification-text]');
    const countNode = notification.querySelector('[data-lh-notification-link] span');
    if (copy) copy.textContent = message;
    if (countNode) countNode.textContent = count;
    notification.classList.add('is-visible');
    notification.setAttribute('aria-hidden', 'false');
    clearTimeout(notificationTimer);
    notificationTimer = window.setTimeout(() => {
      notification.classList.remove('is-visible');
      notification.setAttribute('aria-hidden', 'true');
    }, 4400);
  }

  async function addToCart(form) {
    const submit = form.querySelector('[type="submit"]');
    if (submit?.disabled) return;
    submit?.setAttribute('aria-busy', 'true');
    if (submit) submit.disabled = true;
    try {
      const selectedAddons = [...(form.closest('[data-lh-product-root]')?.querySelectorAll('[data-lh-addon]:checked') || [])];
      const formData = new FormData(form);
      const mainId = formData.get('id');
      const mainQuantity = Math.max(1, Number(formData.get('quantity') || 1));
      const items = [{ id: Number(mainId), quantity: mainQuantity }];
      selectedAddons.forEach((addon) => {
        const id = Number(addon.dataset.variantId || 0);
        if (id) items.push({ id, quantity: 1 });
      });
      const response = await fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'This item could not be added.');
      const cartResponse = await fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      updateCartCount(cart.item_count || 0);
      const addedCount = items.length;
      showNotification(addedCount > 1 ? addedCount + ' items were added to your bag.' : (data.product_title || data.title || 'Item') + ' was added to your bag.', cart.item_count || 0);
    } catch (error) {
      showNotification(error.message || 'This item could not be added.', '');
    } finally {
      submit?.removeAttribute('aria-busy');
      if (submit) submit.disabled = false;
    }
  }

  function initProduct(root) {
    if (root.dataset.lhInitialized === 'true') return;
    root.dataset.lhInitialized = 'true';
    const form = root.querySelector('[data-loom-add-form]');
    const variantsNode = root.querySelector('[data-lh-variants]');
    const idInput = root.querySelector('[data-lh-variant-id]');
    const price = root.querySelector('[data-lh-price]');
    const addLabel = root.querySelector('[data-lh-add-label]');
    const addButton = root.querySelector('[data-lh-add-button]');
    const stock = root.querySelector('[data-lh-stock]');
    const selectionPrice = root.querySelector('[data-lh-selection-price]');
    const selectionOption = root.querySelector('[data-lh-selection-option]');
    const selectionImage = root.querySelector('[data-lh-selection-image]');
    const sku = root.querySelector('[data-lh-sku]');
    const total = root.querySelector('[data-lh-total]');
    const shippingMessage = root.querySelector('[data-lh-shipping-message]');
    const shippingMeter = root.querySelector('[data-lh-shipping-meter]');
    const sticky = root.querySelector('[data-lh-sticky-cart]');
    const stickyPrice = root.querySelector('[data-lh-sticky-price]');
    const stickyOption = root.querySelector('[data-lh-sticky-option]');
    const stickySubmit = root.querySelector('[data-lh-sticky-submit]');
    const stickyOptions = root.querySelector('[data-lh-sticky-options]');
    const stickySheet = root.querySelector('[data-lh-sticky-sheet]');
    const stickySizeLabel = root.querySelector('[data-lh-sticky-size-label]');
    const stickySizeChoices = [...root.querySelectorAll('[data-lh-sticky-size-value]')];
    const galleryMain = root.querySelector('[data-lh-gallery-main], .lh-pb-stage__image');
    const galleryCurrent = root.querySelector('[data-lh-gallery-current]');
    const mobileCarousel = root.querySelector('[data-lh-mobile-carousel]');
    const mobileTrack = mobileCarousel?.querySelector('.lh-pb-mobile-carousel__track');
    const mobileSlides = [...(mobileCarousel?.querySelectorAll('[data-lh-mobile-slide]') || [])];
    const mobileCurrent = root.querySelector('[data-lh-mobile-current]');
    const galleryThumbs = [...root.querySelectorAll('[data-lh-gallery-thumb]')];
    const shippingThreshold = Number(root.dataset.lhShippingThreshold || 0);
    let variants = [];
    try { variants = JSON.parse(variantsNode?.textContent || '[]'); } catch (_) {}
    let currentVariant = variants.find((variant) => String(variant.id) === idInput?.value) || variants[0];

    function showGalleryImage(index, options = {}) {
      if (!galleryThumbs.length || !galleryMain) return;
      const safeIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      const thumb = galleryThumbs[safeIndex];
      galleryMain.src = thumb.dataset.lhGallerySrc || galleryMain.src;
      galleryMain.alt = thumb.dataset.lhGalleryAlt || galleryMain.alt;
      galleryMain.removeAttribute('srcset');
      galleryThumbs.forEach((item, itemIndex) => {
        item.classList.toggle('is-active', itemIndex === safeIndex);
        item.setAttribute('aria-pressed', String(itemIndex === safeIndex));
      });
      if (galleryCurrent) galleryCurrent.textContent = String(safeIndex + 1);
      if (mobileCurrent) mobileCurrent.textContent = String(safeIndex + 1);
      if (options.scrollMobile !== false && mobileTrack && mobileSlides[safeIndex] && window.matchMedia('(max-width: 749px)').matches) {
        mobileTrack.scrollTo({ left: mobileSlides[safeIndex].offsetLeft, behavior: 'smooth' });
      }
    }

    root.querySelector('[data-lh-gallery-prev]')?.addEventListener('click', () => {
      const active = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      showGalleryImage(active - 1);
    });
    root.querySelector('[data-lh-gallery-next]')?.addEventListener('click', () => {
      const active = Math.max(0, galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      showGalleryImage(active + 1);
    });

    function updatePurchaseSummary() {
      if (!currentVariant) return;
      const quantityValue = Math.max(1, Number(root.querySelector('[data-lh-quantity]')?.value || 1));
      const addonTotal = [...root.querySelectorAll('[data-lh-addon]:checked')].reduce((sum, addon) => sum + Number(addon.dataset.price || 0), 0);
      const totalCents = Number(currentVariant.price || 0) * quantityValue + addonTotal;
      if (total) total.textContent = formatMoney(totalCents);
      const remaining = shippingThreshold - totalCents;
      if (shippingMessage) {
        shippingMessage.textContent = remaining <= 0 ? 'Free shipping unlocked' : 'Add ' + formatMoney(remaining) + ' more to unlock free shipping';
      }
      if (shippingMeter) {
        const progress = shippingThreshold > 0 ? Math.min(100, Math.max(0, totalCents / shippingThreshold * 100)) : 100;
        shippingMeter.style.width = progress + '%';
      }
    }

    function selectVariant() {
      const selected = [...root.querySelectorAll('[data-lh-option-group]')].map((group) => {
        return group.querySelector('.is-active')?.dataset.lhOptionValue;
      });
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) return;
      currentVariant = variant;
      if (idInput) idInput.value = variant.id;
      const money = formatMoney(variant.price);
      if (price) price.textContent = money;
      if (selectionPrice) selectionPrice.textContent = money;
      if (selectionOption) selectionOption.textContent = variant.public_title || variant.title;
      if (sku) sku.textContent = variant.sku || '';
      if (stickyPrice) stickyPrice.textContent = money;
      if (stickyOption) stickyOption.textContent = variant.public_title || variant.title;
      if (stickySizeLabel) stickySizeLabel.textContent = variant.options?.[0] || variant.public_title || variant.title;
      stickySizeChoices.forEach((choice) => {
        const active = choice.dataset.lhStickySizeValue === variant.options?.[0];
        choice.classList.toggle('is-active', active);
        choice.setAttribute('aria-pressed', String(active));
      });
      if (addButton) addButton.disabled = !variant.available;
      if (stickySubmit) {
        stickySubmit.disabled = !variant.available;
        stickySubmit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stock) {
        const availabilityText = variant.available
          ? stock.dataset.availableText
          : stock.dataset.unavailableText;
        if (availabilityText) stock.textContent = availabilityText;
      }
      const variantImage = variant.featured_image?.src;
      if (variantImage) {
        if (selectionImage) selectionImage.src = variantImage;
        if (galleryMain) {
          galleryMain.src = variantImage;
          galleryMain.removeAttribute('srcset');
        }
      }
      updatePurchaseSummary();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    root.querySelectorAll('[data-lh-option-value]').forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.closest('[data-lh-option-group]');
        group?.querySelectorAll('[data-lh-option-value]').forEach((item) => item.classList.remove('is-active'));
        group?.querySelectorAll('[data-lh-option-value]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.classList.add('is-active');
        button.setAttribute('aria-pressed', 'true');
        const label = root.querySelector('[data-lh-option-label="' + group?.dataset.lhOptionGroup + '"]');
        if (label) label.textContent = button.dataset.lhOptionValue || '';
        selectVariant();
      });
    });

    const quantity = root.querySelector('[data-lh-quantity]');
    root.querySelector('[data-lh-qty-minus]')?.addEventListener('click', () => {
      quantity.value = Math.max(1, Number(quantity.value || 1) - 1);
      updatePurchaseSummary();
    });
    root.querySelector('[data-lh-qty-plus]')?.addEventListener('click', () => {
      quantity.value = Number(quantity.value || 1) + 1;
      updatePurchaseSummary();
    });
    quantity?.addEventListener('change', updatePurchaseSummary);
    root.querySelectorAll('[data-lh-addon]').forEach((addon) => addon.addEventListener('change', updatePurchaseSummary));
    const openStickyOptions = () => {
      if (!stickySheet) return;
      stickySheet.classList.add('is-open');
      stickySheet.setAttribute('aria-hidden', 'false');
      stickyOptions?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('lh-sticky-sheet-open');
      stickySheet.querySelector('.is-active, [data-lh-sticky-size-value]')?.focus();
    };

    const closeStickyOptions = () => {
      if (!stickySheet) return;
      stickySheet.classList.remove('is-open');
      stickySheet.setAttribute('aria-hidden', 'true');
      stickyOptions?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('lh-sticky-sheet-open');
    };

    stickyOptions?.addEventListener('click', openStickyOptions);
    stickySheet?.querySelectorAll('[data-lh-sticky-sheet-close]').forEach((button) => button.addEventListener('click', closeStickyOptions));
    stickySizeChoices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const value = choice.dataset.lhStickySizeValue;
        const mainChoice = [...root.querySelectorAll('[data-lh-option-value]')].find((button) => button.dataset.lhOptionValue === value);
        mainChoice?.click();
        closeStickyOptions();
        stickyOptions?.focus();
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && stickySheet?.classList.contains('is-open')) closeStickyOptions();
    });

    stickySubmit?.addEventListener('click', () => form?.requestSubmit());
    updatePurchaseSummary();

  }

  function initCollection(section) {
    if (section.dataset.lhInitialized === 'true') return;
    section.dataset.lhInitialized = 'true';
    const drawer = section.querySelector('[data-lh-filter-drawer]');
    const open = () => {
      drawer?.classList.add('is-open');
      drawer?.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    };
    const close = () => {
      drawer?.classList.remove('is-open');
      drawer?.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    section.querySelector('[data-lh-filter-open]')?.addEventListener('click', open);
    section.querySelectorAll('[data-lh-filter-close]').forEach((button) => button.addEventListener('click', close));
    section.querySelector('[data-lh-sort]')?.addEventListener('change', (event) => event.target.form?.submit());
  }

  function initCart(section) {
    if (section.dataset.lhInitialized === 'true') return;
    section.dataset.lhInitialized = 'true';
    section.querySelectorAll('[data-lh-cart-quantity]').forEach((input) => {
      input.closest('.lh-cart-quantity')?.querySelector('[data-lh-cart-minus]')?.addEventListener('click', () => {
        input.value = Math.max(0, Number(input.value || 0) - 1);
      });
      input.closest('.lh-cart-quantity')?.querySelector('[data-lh-cart-plus]')?.addEventListener('click', () => {
        input.value = Number(input.value || 0) + 1;
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-lh-product-root]').forEach(initProduct);
    scope.querySelectorAll('.lh-collection').forEach(initCollection);
    scope.querySelectorAll('.lh-cart-page').forEach(initCart);
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.('[data-loom-add-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });
  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest?.('[data-lh-gallery-thumb]');
    if (thumbnail) {
      event.preventDefault();
      const gallery = thumbnail.closest('[data-lh-gallery]');
      const main = gallery?.querySelector('[data-lh-gallery-main], .lh-pb-stage__image');
      if (main) {
        main.src = thumbnail.dataset.lhGallerySrc || main.src;
        main.alt = thumbnail.dataset.lhGalleryAlt || main.alt;
        main.removeAttribute('srcset');
        const thumbs = [...gallery.querySelectorAll('[data-lh-gallery-thumb]')];
        const index = thumbs.indexOf(thumbnail);
        thumbs.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
          item.setAttribute('aria-pressed', String(itemIndex === index));
        });
        const count = gallery.querySelector('[data-lh-gallery-current]');
        if (count && index >= 0) count.textContent = String(index + 1);
      }
      return;
    }
    if (event.target.closest?.('[data-lh-notification-close]')) {
      const notification = document.querySelector('[data-lh-cart-notification]');
      notification?.classList.remove('is-visible');
      notification?.setAttribute('aria-hidden', 'true');
    }
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  if (window.__lhDogBreedMenuLoaded) return;
  window.__lhDogBreedMenuLoaded = true;

  const fallbackBreedNames = [
    'Bull Terrier',
    'Bulldog',
    'Cavalier King Charles Spaniel',
    'Corgi',
    'Dachshund',
    'Doberman',
    'Golden Retriever',
    'Labrador Retriever',
    'Pit Bull',
    'Poodle',
    'Sheepadoodle',
    'Yorkshire Terrier'
  ];

  const breedSearchAliases = { 'Labrador Retriever': 'Labrador' };
  const breedUrl = (breed) => '/search?q=' + encodeURIComponent('title:"' + (breedSearchAliases[breed] || breed) + '"') + '&type=product';
  const managedBreedItems = (() => {
    try {
      const data = JSON.parse(document.querySelector('#LHDogBreedMenuData')?.textContent || '[]');
      return Array.isArray(data) ? data.filter((item) => item?.title && item?.url) : [];
    } catch (error) {
      return [];
    }
  })();
  const breedItems = (managedBreedItems.length
    ? managedBreedItems
    : fallbackBreedNames.map((title) => ({ title, url: breedUrl(title) })))
    .map((item) => ({ title: String(item.title).trim(), url: String(item.url) }))
    .sort((a, b) => a.title.localeCompare(b.title));
  const breeds = breedItems.map((item) => item.title);
  const breedLinks = Object.fromEntries(breedItems.map((item) => [item.title, item.url]));
  const popularBreeds = [
    'Golden Retriever',
    'Corgi',
    'Dachshund',
    'Poodle',
    'Bulldog',
    'Labrador Retriever'
  ].filter((breed) => breedLinks[breed]);

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  const grouped = breedItems.reduce((groups, item) => {
    const letter = item.title.charAt(0).toUpperCase();
    (groups[letter] ||= []).push(item);
    return groups;
  }, {});

  function groupMarkup(letter, values) {
    return '<details class="lh-dog-menu__group" id="lh-dog-letter-' + letter + '" open>' +
      '<summary><span>' + letter + '</span><span class="lh-dog-menu__group-count">' + values.length + '</span></summary>' +
      '<ul>' + values.map((item) =>
        '<li><a data-lh-dog-breed-link data-breed="' + item.title + '" href="' + item.url + '">' +
        '<span>' + item.title + '</span><span aria-hidden="true">→</span></a></li>'
      ).join('') + '</ul></details>';
  }

  function drawerMarkup() {
    return '<div class="lh-dog-menu" data-lh-dog-menu aria-hidden="true">' +
      '<button class="lh-dog-menu__backdrop" type="button" data-lh-dog-close aria-label="Close dog breeds menu"></button>' +
      '<section class="lh-dog-menu__panel" role="dialog" aria-modal="true" aria-labelledby="lh-dog-menu-title">' +
        '<header class="lh-dog-menu__header">' +
          '<div><p>Shop by animal</p><h2 id="lh-dog-menu-title">Dog Breeds <span>A–Z</span></h2></div>' +
          '<button class="lh-dog-menu__close" type="button" data-lh-dog-close aria-label="Close dog breeds menu">×</button>' +
        '</header>' +
        '<div class="lh-dog-menu__tools">' +
          '<label class="lh-dog-menu__search"><span class="visually-hidden">Search dog breeds</span>' +
            '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg>' +
            '<input type="search" data-lh-dog-search placeholder="Search dog breeds..." autocomplete="off">' +
            '<button type="button" data-lh-dog-clear aria-label="Clear search">×</button>' +
          '</label>' +
          '<nav class="lh-dog-menu__alphabet" aria-label="Dog breeds alphabet">' +
            alphabet.map((letter) =>
              '<button type="button" data-lh-dog-letter="' + letter + '"' + (grouped[letter] ? '' : ' disabled') + '>' + letter + '</button>'
            ).join('') +
          '</nav>' +
        '</div>' +
        '<div class="lh-dog-menu__content">' +
          '<aside class="lh-dog-menu__featured">' +
            '<a class="lh-dog-menu__all" href="/search?q=dog&type=product"><span>Shop all dog bedding</span><span aria-hidden="true">→</span></a>' +
            '<p>Popular breeds</p>' +
            '<ul>' + popularBreeds.map((breed) =>
              '<li><a href="' + breedLinks[breed] + '">' + breed + '</a></li>'
            ).join('') + '</ul>' +
            '<small>Only breeds with active products are shown.</small>' +
          '</aside>' +
          '<div class="lh-dog-menu__directory" data-lh-dog-results>' +
            Object.keys(grouped).sort().map((letter) => groupMarkup(letter, grouped[letter])).join('') +
            '<p class="lh-dog-menu__empty" data-lh-dog-empty hidden>No matching breed found. Try a broader search.</p>' +
          '</div>' +
        '</div>' +
      '</section>' +
    '</div>';
  }

  let lastFocus;

  function syncMobileGroups(drawer) {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    drawer.querySelectorAll('.lh-dog-menu__group').forEach((group, index) => {
      group.open = mobile ? index === 0 : true;
    });
  }

  function openMenu(drawer) {
    syncMobileGroups(drawer);
    lastFocus = document.activeElement;
    const header = document.querySelector('#header-component');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 72;
    drawer.style.setProperty('--lh-dog-menu-top', headerBottom + 'px');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lh-dog-menu-open');
    document.querySelectorAll('[data-lh-dog-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    const mobileDrawer = document.querySelector('#Details-menu-drawer-container');
    if (window.matchMedia('(max-width: 749px)').matches && mobileDrawer?.open) mobileDrawer.removeAttribute('open');
    window.setTimeout(() => drawer.querySelector('[data-lh-dog-search]')?.focus(), 80);
  }

  function closeMenu(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lh-dog-menu-open');
    document.querySelectorAll('[data-lh-dog-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    lastFocus?.focus?.();
  }

  function isDogLink(link) {
    const label = link.textContent.trim().toLowerCase();
    const href = link.getAttribute('href') || '';
    return label === 'dogs' || /(?:[?&]q=dog(?:&|$)|\/collections\/dogs?)/i.test(href);
  }

  function prepareTrigger(trigger, mobile = false) {
    trigger.dataset.lhDogTrigger = '';
    trigger.classList.add(mobile ? 'lh-dog-menu-mobile-trigger' : 'lh-dog-menu-trigger');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function mountTriggers(drawer) {
    const desktopMenu = document.querySelector('header overflow-list');
    const desktopLink = desktopMenu
      ? [...desktopMenu.querySelectorAll('a.menu-list__link')].find(isDogLink)
      : null;
    if (desktopLink) prepareTrigger(desktopLink);

    const mobileMenu = document.querySelector('header .menu-drawer__menu');
    const mobileLink = mobileMenu
      ? [...mobileMenu.querySelectorAll('a.menu-drawer__menu-item')].find(isDogLink)
      : null;
    if (mobileLink) prepareTrigger(mobileLink, true);

    document.querySelectorAll('[data-lh-dog-trigger]').forEach((trigger) => {
      if (trigger.dataset.lhDogBound) return;
      trigger.dataset.lhDogBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openMenu(drawer);
      });
    });
  }

  function initDogMenu() {
    let drawer = document.querySelector('[data-lh-dog-menu]');
    if (!drawer) {
      document.body.insertAdjacentHTML('beforeend', drawerMarkup());
      drawer = document.querySelector('[data-lh-dog-menu]');
    }

    syncMobileGroups(drawer);
    mountTriggers(drawer);

    drawer.querySelectorAll('[data-lh-dog-close]').forEach((button) => button.addEventListener('click', () => closeMenu(drawer)));

    const input = drawer.querySelector('[data-lh-dog-search]');
    const clearButton = drawer.querySelector('[data-lh-dog-clear]');
    const empty = drawer.querySelector('[data-lh-dog-empty]');

    function filterBreeds() {
      const query = normalize(input.value.trim());
      let visibleCount = 0;
      drawer.querySelectorAll('.lh-dog-menu__group').forEach((group) => {
        let groupCount = 0;
        group.querySelectorAll('[data-lh-dog-breed-link]').forEach((link) => {
          const matches = !query || normalize(link.dataset.breed).includes(query);
          link.closest('li').hidden = !matches;
          if (matches) groupCount += 1;
        });
        group.hidden = groupCount === 0;
        if (query && groupCount) group.open = true;
        visibleCount += groupCount;
      });
      empty.hidden = visibleCount > 0;
      clearButton.classList.toggle('is-visible', Boolean(input.value));
    }

    input.addEventListener('input', filterBreeds);
    clearButton.addEventListener('click', () => {
      input.value = '';
      filterBreeds();
      input.focus();
    });

    drawer.querySelectorAll('[data-lh-dog-letter]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = drawer.querySelector('#lh-dog-letter-' + button.dataset.lhDogLetter);
        if (!target) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          drawer.querySelectorAll('.lh-dog-menu__group').forEach((group) => group.open = group === target);
        }
        target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu(drawer);
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), summary')].filter((element) => !element.closest('[hidden]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (drawer.classList.contains('is-open')) {
        const header = document.querySelector('#header-component');
        drawer.style.setProperty('--lh-dog-menu-top', (header ? Math.max(0, header.getBoundingClientRect().bottom) : 72) + 'px');
      }
    }, { passive: true });

    document.addEventListener('shopify:section:load', () => mountTriggers(drawer));
    new MutationObserver(() => mountTriggers(drawer)).observe(document.querySelector('header') || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDogMenu, { once: true });
  } else {
    initDogMenu();
  }
})();

(() => {
  if (window.__lhAnimalMenuLoaded) return;
  window.__lhAnimalMenuLoaded = true;

  const animalItems = (() => {
    try {
      const data = JSON.parse(document.querySelector('#LHAnimalMenuData')?.textContent || '[]');
      return Array.isArray(data)
        ? data.filter((item) => item?.title && item?.url)
          .map((item) => ({ title: String(item.title).trim(), url: String(item.url) }))
          .sort((a, b) => a.title.localeCompare(b.title))
        : [];
    } catch (error) {
      return [];
    }
  })();

  if (!animalItems.length) return;

  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const itemLinks = Object.fromEntries(animalItems.map((item) => [item.title, item.url]));
  const popularAnimals = ['Dragon', 'Horse', 'Owl', 'Butterfly', 'Flamingo', 'Cow'].filter((title) => itemLinks[title]);
  const grouped = animalItems.reduce((groups, item) => {
    const letter = item.title.charAt(0).toUpperCase();
    (groups[letter] ||= []).push(item);
    return groups;
  }, {});

  function groupMarkup(letter, values) {
    return '<details class="lh-dog-menu__group" id="lh-animal-letter-' + letter + '" open>' +
      '<summary><span>' + letter + '</span><span class="lh-dog-menu__group-count">' + values.length + '</span></summary>' +
      '<ul>' + values.map((item) =>
        '<li><a data-lh-animal-link data-animal="' + item.title + '" href="' + item.url + '">' +
        '<span>' + item.title + '</span><span aria-hidden="true">→</span></a></li>'
      ).join('') + '</ul></details>';
  }

  function drawerMarkup() {
    return '<div class="lh-dog-menu" data-lh-animal-menu aria-hidden="true">' +
      '<button class="lh-dog-menu__backdrop" type="button" data-lh-animal-close aria-label="Close animal collections menu"></button>' +
      '<section class="lh-dog-menu__panel" role="dialog" aria-modal="true" aria-labelledby="lh-animal-menu-title">' +
        '<header class="lh-dog-menu__header">' +
          '<div><p>Shop by animal</p><h2 id="lh-animal-menu-title">Animal Collections <span>A–Z</span></h2></div>' +
          '<button class="lh-dog-menu__close" type="button" data-lh-animal-close aria-label="Close animal collections menu">×</button>' +
        '</header>' +
        '<div class="lh-dog-menu__tools">' +
          '<label class="lh-dog-menu__search"><span class="visually-hidden">Search animal collections</span>' +
            '<svg aria-hidden="true" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-4-4"></path></svg>' +
            '<input type="search" data-lh-animal-search placeholder="Search animal collections..." autocomplete="off">' +
            '<button type="button" data-lh-animal-clear aria-label="Clear search">×</button>' +
          '</label>' +
          '<nav class="lh-dog-menu__alphabet" aria-label="Animal collections alphabet">' +
            alphabet.map((letter) =>
              '<button type="button" data-lh-animal-letter="' + letter + '"' + (grouped[letter] ? '' : ' disabled') + '>' + letter + '</button>'
            ).join('') +
          '</nav>' +
        '</div>' +
        '<div class="lh-dog-menu__content">' +
          '<aside class="lh-dog-menu__featured">' +
            '<a class="lh-dog-menu__all" href="/collections/all"><span>Shop all quilt bedding</span><span aria-hidden="true">→</span></a>' +
            '<p>Popular animals</p>' +
            '<ul>' + popularAnimals.map((title) =>
              '<li><a href="' + itemLinks[title] + '">' + title + '</a></li>'
            ).join('') + '</ul>' +
            '<small>Browse curated animal collections with active products.</small>' +
          '</aside>' +
          '<div class="lh-dog-menu__directory" data-lh-animal-results>' +
            Object.keys(grouped).sort().map((letter) => groupMarkup(letter, grouped[letter])).join('') +
            '<p class="lh-dog-menu__empty" data-lh-animal-empty hidden>No matching animal found. Try a broader search.</p>' +
          '</div>' +
        '</div>' +
      '</section>' +
    '</div>';
  }

  let lastFocus;

  function syncMobileGroups(drawer) {
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    drawer.querySelectorAll('.lh-dog-menu__group').forEach((group, index) => {
      group.open = mobile ? index === 0 : true;
    });
  }

  function openMenu(drawer) {
    document.querySelector('[data-lh-dog-menu].is-open [data-lh-dog-close]')?.click();
    syncMobileGroups(drawer);
    lastFocus = document.activeElement;
    const header = document.querySelector('#header-component');
    const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 72;
    drawer.style.setProperty('--lh-dog-menu-top', headerBottom + 'px');
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lh-dog-menu-open');
    document.querySelectorAll('[data-lh-animal-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
    const mobileDrawer = document.querySelector('#Details-menu-drawer-container');
    if (window.matchMedia('(max-width: 749px)').matches && mobileDrawer?.open) mobileDrawer.removeAttribute('open');
    window.setTimeout(() => drawer.querySelector('[data-lh-animal-search]')?.focus(), 80);
  }

  function closeMenu(drawer) {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lh-dog-menu-open');
    document.querySelectorAll('[data-lh-animal-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    lastFocus?.focus?.();
  }

  function isAnimalTrigger(element) {
    return element.querySelector('.menu-list__link-title, .menu-drawer__menu-item-text')?.textContent.trim().toLowerCase() === 'animals';
  }

  function prepareTrigger(trigger, mobile = false) {
    trigger.dataset.lhAnimalTrigger = '';
    trigger.classList.add(mobile ? 'lh-dog-menu-mobile-trigger' : 'lh-dog-menu-trigger');
    if (mobile && trigger.tagName !== 'A' && trigger.tagName !== 'BUTTON' && trigger.tagName !== 'SUMMARY') {
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
    }
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    const navItem = trigger.closest('.menu-list__list-item');
    navItem?.setAttribute('data-lh-animal-nav-item', '');

    // Animals uses the custom A–Z dialog. Keep Horizon's native hover submenu
    // in the DOM as the data source, but prevent it from opening as a second UI.
    const nativeSubmenu = navItem?.querySelector(':scope > .menu-list__submenu');
    if (nativeSubmenu) {
      nativeSubmenu.hidden = true;
      nativeSubmenu.setAttribute('inert', '');
      trigger.removeAttribute('aria-controls');
    }
  }

  function mountTriggers(drawer) {
    const desktopMenu = document.querySelector('header overflow-list');
    const desktopTrigger = desktopMenu
      ? [...desktopMenu.querySelectorAll('.menu-list__link')].find(isAnimalTrigger)
      : null;
    if (desktopTrigger) prepareTrigger(desktopTrigger);

    const mobileTrigger = [...document.querySelectorAll('header .menu-drawer__menu-item')].find(isAnimalTrigger) || null;
    if (mobileTrigger) prepareTrigger(mobileTrigger, true);

    document.querySelectorAll('[data-lh-animal-trigger]').forEach((trigger) => {
      if (trigger.dataset.lhAnimalBound) return;
      trigger.dataset.lhAnimalBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        openMenu(drawer);
      }, true);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        openMenu(drawer);
      }, true);
    });
  }

  function initAnimalMenu() {
    let drawer = document.querySelector('[data-lh-animal-menu]');
    if (!drawer) {
      document.body.insertAdjacentHTML('beforeend', drawerMarkup());
      drawer = document.querySelector('[data-lh-animal-menu]');
    }

    syncMobileGroups(drawer);
    mountTriggers(drawer);
    drawer.querySelectorAll('[data-lh-animal-close]').forEach((button) => button.addEventListener('click', () => closeMenu(drawer)));

    const input = drawer.querySelector('[data-lh-animal-search]');
    const clearButton = drawer.querySelector('[data-lh-animal-clear]');
    const empty = drawer.querySelector('[data-lh-animal-empty]');

    function filterAnimals() {
      const query = normalize(input.value.trim());
      let visibleCount = 0;
      drawer.querySelectorAll('.lh-dog-menu__group').forEach((group) => {
        let groupCount = 0;
        group.querySelectorAll('[data-lh-animal-link]').forEach((link) => {
          const matches = !query || normalize(link.dataset.animal).includes(query);
          link.closest('li').hidden = !matches;
          if (matches) groupCount += 1;
        });
        group.hidden = groupCount === 0;
        if (query && groupCount) group.open = true;
        visibleCount += groupCount;
      });
      empty.hidden = visibleCount > 0;
      clearButton.classList.toggle('is-visible', Boolean(input.value));
    }

    input.addEventListener('input', filterAnimals);
    clearButton.addEventListener('click', () => {
      input.value = '';
      filterAnimals();
      input.focus();
    });

    drawer.querySelectorAll('[data-lh-animal-letter]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = drawer.querySelector('#lh-animal-letter-' + button.dataset.lhAnimalLetter);
        if (!target) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          drawer.querySelectorAll('.lh-dog-menu__group').forEach((group) => group.open = group === target);
        }
        target.open = true;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu(drawer);
      if (event.key !== 'Tab') return;
      const focusable = [...drawer.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), summary')].filter((element) => !element.closest('[hidden]'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (drawer.classList.contains('is-open')) {
        const header = document.querySelector('#header-component');
        drawer.style.setProperty('--lh-dog-menu-top', (header ? Math.max(0, header.getBoundingClientRect().bottom) : 72) + 'px');
      }
    }, { passive: true });

    document.addEventListener('shopify:section:load', () => mountTriggers(drawer));
    new MutationObserver(() => mountTriggers(drawer)).observe(document.querySelector('header') || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimalMenu, { once: true });
  } else {
    initAnimalMenu();
  }
})();

(() => {
  if (window.__lhPdpConversionLoaded) return;
  window.__lhPdpConversionLoaded = true;

  function initPdpConversion(root = document) {
    const scopedPdp = root.matches?.('.lh-pb-pdp') ? root : root.querySelector?.('.lh-pb-pdp');
    const pdp = scopedPdp || document.querySelector('.lh-pb-pdp');
    if (!pdp || pdp.dataset.lhConversionReady) return;
    pdp.dataset.lhConversionReady = 'true';

    const sticky = pdp.querySelector('.lh-sticky-cart');
    const primaryButton = pdp.querySelector('[data-lh-add-button]');
    if (sticky && primaryButton) {
      sticky.classList.add('lh-sticky-cart--enhanced');
      sticky.setAttribute('aria-hidden', 'true');

      const updateSticky = () => {
        const rect = primaryButton.getBoundingClientRect();
        const primaryVisible = rect.top < window.innerHeight && rect.bottom > 0;
        const shouldShow = window.scrollY > 240 && !primaryVisible;
        sticky.classList.toggle('is-visible', shouldShow);
        sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      };

      updateSticky();
      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky, { passive: true });
    }

    const sizeGroup = [...pdp.querySelectorAll('fieldset')].find((fieldset) =>
      fieldset.querySelector('legend')?.textContent.trim().startsWith('Size:')
    );
    if (sizeGroup && !pdp.querySelector('.lh-pdp-size-note')) {
      const note = document.createElement('p');
      note.className = 'lh-pdp-size-note';
      note.textContent = 'Sizing tip: choose a larger size for extra side coverage and a relaxed, layered look.';
      sizeGroup.insertAdjacentElement('afterend', note);
    }

    const relatedSections = [...pdp.querySelectorAll('.lh-pb-related:not(.lh-pb-related--similar)')];
    relatedSections.forEach((section) => {
      const heading = section.querySelector('h2');
      if (heading) heading.textContent = 'Complete the room';
      if (!section.querySelector('.lh-pb-related__intro')) {
        const intro = document.createElement('p');
        intro.className = 'lh-pb-related__intro';
        intro.textContent = 'Add another design for a guest room, seasonal refresh or thoughtful gift — and get closer to free shipping.';
        const grid = section.querySelector('.lh-product-grid');
        grid ? section.insertBefore(intro, grid) : section.appendChild(intro);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initPdpConversion(), { once: true });
  } else {
    initPdpConversion();
  }

  document.addEventListener('shopify:section:load', (event) => initPdpConversion(event.target));
})();


(() => {
  if (window.__lhNativeCarouselSync) return;
  window.__lhNativeCarouselSync = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  let scrollFrame = 0;

  const updateState = (gallery, index) => {
    const thumbs = [...gallery.querySelectorAll('[data-lh-gallery-thumb]')];
    const safeIndex = Math.max(0, Math.min(thumbs.length - 1, index));
    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === safeIndex);
      thumb.setAttribute('aria-pressed', String(thumbIndex === safeIndex));
    });
    const desktopCount = gallery.querySelector('[data-lh-gallery-current]');
    const mobileCount = gallery.querySelector('[data-lh-mobile-current]');
    if (desktopCount) desktopCount.textContent = String(safeIndex + 1);
    if (mobileCount) mobileCount.textContent = String(safeIndex + 1);
    const main = gallery.querySelector('[data-lh-gallery-main], .lh-pb-stage__image, .lh-pb-stage img');
    const thumb = thumbs[safeIndex];
    if (main && thumb) {
      main.src = thumb.dataset.lhGallerySrc || main.src;
      main.alt = thumb.dataset.lhGalleryAlt || main.alt;
      main.removeAttribute('srcset');
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    const thumb = target?.closest('[data-lh-gallery-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-lh-gallery]');
    const track = gallery?.querySelector('.lh-pb-mobile-carousel__track');
    const thumbs = [...(gallery?.querySelectorAll('[data-lh-gallery-thumb]') || [])];
    const index = thumbs.indexOf(thumb);
    if (index < 0) return;

    if (!mobile.matches) {
      updateState(gallery, index);
      return;
    }

    if (!track) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    updateState(gallery, index);
  }, true);

  document.addEventListener('scroll', (event) => {
    const track = event.target instanceof Element ? event.target.closest('.lh-pb-mobile-carousel__track') : null;
    if (!track || !mobile.matches) return;
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(() => {
      const gallery = track.closest('[data-lh-gallery]');
      if (!gallery) return;
      const slideCount = track.querySelectorAll('[data-lh-mobile-slide]').length;
      const index = Math.max(0, Math.min(slideCount - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      updateState(gallery, index);
    });
  }, true);
})();
